export default __webpack_public_path__ + "static/media/nao.e06e822b.jpg";